import type { PriceCompareResponse } from "../types";

/** Session-level client cache (spec §19): a repeat scan of the same barcode within TTL renders instantly, no RPC round trip. */
export class PriceCache {
  private readonly entries = new Map<string, { result: PriceCompareResponse; expiresAt: number }>();

  constructor(private readonly ttlMs: number = 60_000) {}

  get(barcode: string, now: number): PriceCompareResponse | null {
    const entry = this.entries.get(barcode);
    if (!entry) return null;
    if (now >= entry.expiresAt) {
      this.entries.delete(barcode);
      return null;
    }
    return entry.result;
  }

  set(barcode: string, result: PriceCompareResponse, now: number): void {
    this.entries.set(barcode, { result, expiresAt: now + this.ttlMs });
  }
}
